<template>
  <div>
    <template v-if="eventsCount == -1">
      <loading></loading>
    </template>
    <template v-else-if="eventsCount == 0">
      <p class="pg-performer-events--label--no_events">イベントはありません</p>
    </template>
    <template v-else-if="eventsCount >= 1">
      <template v-for="(event, index) in events">
        <div class="col-xs-12 pg-performer-events--wrap--event" v-on:click="redirect_event_page(event.id)">
          <div class="col-xs-7 pg-performer-events--image--event">
            <img :src="event.image" :title="event.title" class="pg-performer-events--image__little">
          </div>
          <h3 class="pg-performer-events--label__bold">{{event.title}}</h3>
          <p class="pg-performer-events--label__nomal">開催 ： {{event.play_date}}</p>
          <p class="pg-performer-events--label__nomal">出演 ： {{event.performers}}</p>
        </div>
      </template>
      <div class="col-xs-12 pg-performer--wrap--disp_more_link">
        <template v-if="disp_more_link">
          <div v-on:click="get_more_events" class="pg-performer-events--button__gray">さらに表示</div>
        </template>
        <template v-else>
          <template v-if="disp_loading">
            <loading></loading>
          </template>
        </template>
      </div>
    </template>
  </div>
</template>

<script>
import consts from '../utils/consts'

export default {
  props: {
    get_events_path: { type: String, required: true },
    event_path: { type: String, required: true }
  },
  data() {
    return {
      p_id: 0,
      page: 1,
      disp_more_link: false,
      disp_loading: true,
    }
  },
  created(){
    this.p_id = location.pathname.split("/")[2]
    // イベント取得
    this.get_events()
  },
  computed:{
    events: function() {
      var events = this.$store.getters['performer/events']
      this.set_more_events_status(events.length)
      scrollBy(0, -1); // スクロールイベントを発火させる
      return events
    },
    eventsCount: function() {
      var length =  this.$store.getters['performer/length']
      return length
    },
    consts: function() {
      return consts;
    },
  },
  methods: {
    // イベント取得
    get_events: function(){
      return this.$store.dispatch('performer/getEvents', {api_path: this.get_events_path, p: this.p_id, page: this.page, per: 10})
    },
    // もっと見る押下イベント
    get_more_events: function() {
      this.page ++
      var events = this.get_events()
      return events
    },
    // もっと見る
    set_more_events_status: function(events_count) {
      if (events_count >= this.consts.PERFORMER_EVENTS.PER_PAGE_EVENTS_NUM * this.page){
        this.disp_more_link = true
        this.disp_loading = true
      } else {
        this.disp_more_link = false
        // ローディング制御
        if (events_count >= this.eventsCount && events_count != 0) {
          this.disp_loading = false
        } else {
          this.disp_loading = true
        }
      }
    },
    // イベント詳細ページへの遷移
    redirect_event_page: function(event_id) {
      window.location.href = this.event_path + event_id;
    }
  },
}
</script>


<style lang="scss" scoped>
  @import '../packs/application.css';

  .pg-performer-events--image__little {
    width: 158px;
    height: 158px;
    border: 1px solid #f0f0f0;
    object-fit: cover;
  }

  .pg-performer-events--label__bold {
    font-size: 1em;
    font-weight: 600;
    color: #333;
    margin-top: 0;
    margin-bottom: 0;
    padding: 0;
    display: -webkit-box;
    text-align: left;
    overflow: hidden;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }

  .pg-performer-events--label__nomal {
    font-size: 1em;
    color: #666;
    display: -webkit-box;
    overflow: hidden;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }

  .pg-performer-events--button__gray--dummy {
    margin-top: 35px;
  }

  .pg-performer-events--button__gray {
    text-align: center;
    background-color: #fff;
    border-radius: 30px;
    border: 1px solid #d7d7d7;
    color: #999;
    display: block;
    width: 300px;
    height: 45px;
    margin: 0 auto;
    margin-top: 20px;
    padding-top: 10px;
    font-weight: bold;
    font-size: 15px;
  }

  .pg-performer-events--image--event {
    max-width: 160px;
    padding-left: 0;
    margin-right: 15px;
  }

  .pg-performer-events--wrap--event {
    padding: 0 0 20px 0;
    cursor: pointer;
  }
  .pg-performer-events--wrap--event:hover {
    opacity: 0.5 ;
  }

  .pg-performer--wrap--disp_more_link {
    margin-bottom: 40px;
  }

  .pg-performer-events--label--no_events {
    margin-bottom: 30px;
  }

  @media screen and (max-width: 767px) {
    .pg-performer-events--image__little {
      width: 99px;
      height: 99px;
      border: 1px solid #f0f0f0;
      object-fit: cover;
    }
    .pg-performer-events--image--event {
      max-width: 100px;
    }
    .pg-performer-events--label__nomal {
      -webkit-line-clamp: 2;
    }
  }

</style>
